import React from 'react';
import TextContent from '../components/contentdata/TextContent';



const electricianJob = {
  title: "Electrician",
  location: "Richmond, Virginia",
  description: [<TextContent.ELECTRICAL_JOB />],
  // More details can be added here
};

const JobDescriptionPage = () => {
  return (
    <div className="JobDetailPage">
      <div className="JobContent">
        <div className="JobHeader">
          <h1>{electricianJob.title}</h1>
          <span>{electricianJob.location}</span>
        </div>
        {electricianJob.description.map((item, index) => (
          <p key={index}>{item}</p>
        ))}
      </div>
      <div className="JobSidebar">
        <div className="SidebarSection">
          <h2>Location</h2>
          <div>{electricianJob.location}</div>
        </div>
        <div className="SidebarSection">
          <h2>Compensation</h2>
          <div>{electricianJob.compensation}</div>
        </div>
        {/* Additional sidebar sections can be added here */}
      </div>
    </div>
  );
};

export default JobDescriptionPage;
